import { getAssetUrl } from '@/stores/assets'
import { useSelector } from '@/stores/hooks'
import type { Line, PartialLine } from '@common/types/Line'
import { contrastColor } from '@lc/libluminance'
import { classes } from '@lc/libreact'
import type { ComponentProps } from 'react'
import { AssetSvg, Svg } from '../foundation/Svg'
import styles from './LinePicto.scss'

// TODO: do better
function slugify(str: string): string {
	return str
		.replaceAll(/[^a-zA-Z0-9_]+/g, '_')
		.replaceAll(/_+/g, '_')
		.replace(/^_/, '')
		.replace(/_$/, '')
}

// TODO: do that in wynd, not shiva
function lineColors(line: PartialLine): [color: string, textColor: string] {
	const color = line.color ? '#' + line.color : '#000000'
	const textColor = line.textColor
		? '#' + line.textColor
		: contrastColor(color)
	return [color, textColor]
}

export function ModePicto({
	mode,
	className,
	...props
}: { mode: string } & Omit<ComponentProps<'span'>, 'children'>) {
	let modesTable = useSelector(state => getAssetUrl(state, 'modes.svg'))
	const modePicto = useSelector(state =>
		getAssetUrl(state, `modes/${mode}.svg`),
	)

	if (!modesTable && !modePicto) {
		console.warn(`No picto found for mode ${mode}`)
	}

	if (modePicto) modesTable = undefined

	return (
		// !@TODO: Explosion
		<span
			data-mode={mode}
			className={classes(styles.modePictoWrapper, className)}
			{...props}
		>
			{!!modesTable && (
				<Svg
					className={styles.modePicto}
					url={modesTable}
					name={slugify(mode)}
					aria-label=""
				/>
			)}
			{!!modePicto && (
				<img
					className={styles.modePicto}
					src={modePicto}
					aria-label=""
					alt=""
				/>
			)}
		</span>
	)
}

export function LinePicto({
	line,
	mode = false,
	className,
	severityDisruption,
	...props
}: {
	line: PartialLine | Line
	mode?: boolean
	severityDisruption?: 'warning' | 'blocking' | 'info' | null
} & Omit<ComponentProps<'span'>, 'children'>) {
	let linesTable = useSelector(state => getAssetUrl(state, 'lines.svg'))
	const linePicto = useSelector(state =>
		getAssetUrl(state, `lines/${line.id}.svg`),
	)

	if (linePicto) linesTable = undefined
	const lineSpan = !linesTable && !linePicto

	const [color, textColor] = lineColors(line)

	return (
		<span
			data-line={line.id}
			className={classes(styles.linePictoWrapper, className)}
			{...props}
		>
			{mode && <ModePicto mode={line.mode} />}
			{linesTable && (
				<Svg
					className={styles.linePictoSvg}
					url={linesTable}
					name={slugify(line.id)}
					aria-label={line.code}
				/>
			)}
			{linePicto && (
				<img
					className={styles.linePictoSvg}
					src={linePicto}
					alt={line.code}
					aria-label={line.code}
				/>
			)}
			{lineSpan && (
				<span
					className={styles.linePictoSpan}
					style={{
						color: textColor,
						background: color,
					}}
				>
					{line.code}
				</span>
			)}
			{severityDisruption !== null && severityDisruption && (
				<div
					className={classes(
						styles.severityDisruptionContainer,
						styles[`${severityDisruption}`],
					)}
				>
					<AssetSvg
						name={
							severityDisruption === 'blocking'
								? 'assets/CrossCircle.svg'
								: severityDisruption === 'warning'
									? 'assets/Warning.svg'
									: 'assets/Information.svg'
						}
						className={styles.iconDisruption}
					/>
				</div>
			)}
		</span>
	)
}
